<router-outlet></router-outlet>

<!-- Modal confirming deletion of addable pair -->
<clr-modal class = "modal-session-timeout" [(clrModalOpen)]="userSessionWarning" [clrModalSize]="'lg'">
    <h3 class="modal-title">Warning: Session Time Out</h3>
    <div class="modal-body">
      <p>Your session is about to expire due to inactivity. You will be automatically logged out in {{countDown.mins}} minutes and {{countDown.sec}} seconds.  Any unsaved changes will be lost. Do you want to stay signed in?</p>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-outline" (click)="refreshUserSession()">
        Stay logged in
      </button>
      <button type="button" class="btn btn-secondary" (click)="logout()">
        Log out
      </button>
    </div>
  </clr-modal>
